import styled from "styled-components";

export const StyledResponsesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .response-card {
    position: relative;
    width: 100%;
    min-height: 70px;
    padding: 14px 16px;
    padding-top: 18px;
    border: none;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0 2px 8px 0 #7e8aad33;
    cursor: pointer;
    text-align: right;
    display: flex;
    align-items: center;
    gap: 12px;
    box-sizing: border-box;
    overflow: hidden;
    font: inherit;
    color: inherit;
    transition:
      transform 0.15s ease,
      box-shadow 0.15s ease;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 10px;
      background: linear-gradient(90deg, #004ef7 0%, #00eab2 100%);
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 14px 0 #7e8aad44;
    }

    .response-card-text {
      flex: 1;
      margin: 0;
      min-width: 0;
      font-family: "Noto Sans Hebrew", sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 16px;
      line-height: 1.45;
      letter-spacing: -0.22px;
      text-align: center;
      color: #122243;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .response-card-icon {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      border-radius: 50%;
      transition: background-color 0.2s ease;
      z-index: 2;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }

      .response-card-icon-img {
        display: block;
        width: 22px;
        height: 22px;
        object-fit: contain;

        &.loading {
          animation: spin 1s linear infinite;
        }
      }
    }
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;
